import { ReaderTypes } from '../../enums/file-reader/reader-types';
import { FileReaderConfigTypes } from '../../types/file-reader-config-types';

export class FileReaderTemplatePayload {
	stageFileID: string;
	readerType: ReaderTypes;
	fileReaderConfig: FileReaderConfigTypes;

	constructor(
		stageFileID: string,
		readerType: ReaderTypes,
		fileReaderConfig: FileReaderConfigTypes
	) {
		this.stageFileID = stageFileID;
		this.readerType = readerType;
		this.fileReaderConfig = fileReaderConfig;
	}
}
